module.exports = __webpack_public_path__ + "static/media/bg-right.a715f86a.svg";